import { hiddenDots } from 'src/components/pages/Case/helpers/hiddenDots';
import { REPORT_SOURCE } from '../types';

export const graphQLReportSourceToLocalReportSource = (
  graphQLReportSource: string,
  viewPermission: boolean = true,
): REPORT_SOURCE | string => {
  if (!viewPermission) return hiddenDots;

  switch (graphQLReportSource) {
    case 'app':
      return REPORT_SOURCE['app'];
    case 'open-reporting':
      return REPORT_SOURCE['open-reporting'];
    case 'resolution-hub':
      return REPORT_SOURCE['resolution-hub'];
    case 'manual-case-creation':
      return REPORT_SOURCE['manual-case-creation'];
    case 'vault-talk':
      return REPORT_SOURCE['vault-talk'];
    case 'slack':
      return REPORT_SOURCE['slack'];
    case 'imported':
      return REPORT_SOURCE['imported'];
    case 'reporter-portal':
      return REPORT_SOURCE['reporter-portal'];
    case 'unknown':
      return REPORT_SOURCE['unknown'];
    default:
      return REPORT_SOURCE['unknown'];
  }
};
